// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rx81","controls":"styles_controls__1E7c8","charLimit":"styles_charLimit__nTK6y","input":"styles_input__3NINL","send":"styles_send__2AlQV"};